import styled, { createGlobalStyle, css } from 'styled-components';

export const FieldLabel = styled.label`
    && {
        display: block;
        font-size: 12px;
        color: ${({ theme }) => theme.colors.antdTextSecondary} !important;
        margin-bottom: 5px;
    }
`;

export const Section = styled.div`
    margin-bottom: 18px;
`;

export const SectionTitle = styled.div`
    font-size: 11px;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.lightFont};
    text-transform: uppercase;
    letter-spacing: 0.06em;
    margin-bottom: 10px;
`;

export const FieldsGrid = styled.div`
    display: grid;
    gap: 10px;
    grid-template-columns: 1fr;
`;

export const ReferenceCard = styled.div`
    display: flex;
    gap: 12px;
    align-items: center;
    background: ${({ theme }) => theme.colors.colorFillAlter};
    border: 1px solid ${({ theme }) => theme.colors.antdBorderSecondary};
    border-radius: 10px;
    padding: 12px;
    margin-bottom: 14px;
`;

export const ReferenceAvatar = styled.div<{ bg: string }>`
    width: 48px;
    height: 48px;
    border-radius: 10px;
    flex-shrink: 0;
    background: ${({ bg }) => bg};
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 700;
`;

export const ReferenceInfo = styled.div`
    min-width: 0;
    flex: 1;
`;

export const ReferenceName = styled.div`
    font-size: 15px;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.antdText};
`;

export const ReferenceMeta = styled.div`
    font-size: 12px;
    color: ${({ theme }) => theme.colors.lightFont};
    font-family: 'SFMono-Regular', Consolas, monospace;
`;

export const EditToggleButton = styled.button`
    width: 32px;
    height: 32px;
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.colors.antdBorderSecondary};
    background: ${({ theme }) => theme.colors.componentBackground};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: ${({ theme }) => theme.colors.lightFont};
    flex-shrink: 0;
`;

export const ReplicateStoresList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const SELECT_POPUP_CLASS = 'quick-adjust-select-popup';

export const SelectPopupGlobalStyle = createGlobalStyle`
    .${SELECT_POPUP_CLASS}.ant-select-dropdown {
        padding: 6px;
        border: 1px solid ${({ theme }) => theme.colors.antdBorderSecondary};
        border-radius: 10px;
        box-shadow: ${({ theme }) => theme.colors.boxShadowSecondary};
    }

    .${SELECT_POPUP_CLASS} .ant-select-item-option {
        border-radius: 8px;
    }

    .${SELECT_POPUP_CLASS} .ant-select-item-option-active:not(.ant-select-item-option-selected) {
        background: ${({ theme }) => theme.colors.colorFillTertiary};
    }

    .${SELECT_POPUP_CLASS} .ant-select-item-option-selected {
        background: ${({ theme }) => theme.colors.colorPrimaryBg};
        color: ${({ theme }) => theme.colors.accentColor};
    }
`;

export const Body = styled.div`
    .ant-input:not(.ant-input-affix-wrapper),
    .ant-input-affix-wrapper,
    .ant-picker,
    .ant-select {
        height: 42px;
        border-radius: 10px;
        border-color: ${({ theme }) => theme.colors.antdBorderSecondary};
        background: ${({ theme }) => theme.colors.colorBgContainer};
        font-size: 14px;
    }

    .ant-input:not(.ant-input-affix-wrapper),
    .ant-input-affix-wrapper,
    .ant-picker {
        padding: 0 11px;
        color: ${({ theme }) => theme.colors.antdText};
    }

    .ant-select {
        padding: 0 12px;
        color: ${({ theme }) => theme.colors.antdText};
    }

    .ant-input:not(.ant-input-affix-wrapper):hover,
    .ant-input-affix-wrapper:hover,
    .ant-picker:hover,
    .ant-select:hover {
        border-color: ${({ theme }) => theme.colors.secondaryColor};
    }

    .ant-input:focus,
    .ant-input-affix-wrapper-focused,
    .ant-picker-focused,
    .ant-select-focused {
        border-color: ${({ theme }) => theme.colors.accentColor};
        box-shadow: none;
    }

    .ant-input-status-error:not(.ant-input-disabled),
    .ant-input-status-error:not(.ant-input-disabled):hover {
        border-color: ${({ theme }) => theme.colors.colorError};
    }

    .ant-input::placeholder,
    .ant-picker input::placeholder,
    .ant-select-placeholder {
        color: ${({ theme }) => theme.colors.colorTextPlaceholder};
    }

    .qa-mono {
        font-family: 'SFMono-Regular', Consolas, monospace;
    }
`;

export const HeaderRow = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
`;

export const HeaderTitle = styled.div`
    font-size: 17px;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.antdText};
`;

export const HeaderSubtitle = styled.div`
    font-size: 12px;
    color: ${({ theme }) => theme.colors.lightFont};
    margin-top: 2px;
`;

export const CloseButton = styled.button`
    width: 32px;
    height: 32px;
    flex-shrink: 0;
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.colors.antdBorderSecondary};
    background: ${({ theme }) => theme.colors.colorBgContainer};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: ${({ theme }) => theme.colors.lightFont};
`;

export const BarcodeInputGroup = styled.div`
    display: flex;
`;

export const BarcodeInput = styled.input`
    flex: 1;
    min-width: 0;
    height: 44px;
    padding: 0 12px;
    border: 1px solid ${({ theme }) => theme.colors.antdBorderSecondary};
    border-right: none;
    border-radius: 10px 0 0 10px;
    font-family: 'SFMono-Regular', Consolas, monospace;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.antdText};
    background: ${({ theme }) => theme.colors.colorBgContainer};
    outline: none;

    &::placeholder {
        color: ${({ theme }) => theme.colors.colorTextPlaceholder};
    }

    &:focus {
        border-color: ${({ theme }) => theme.colors.accentColor};
    }
`;

export const ScanButton = styled.button`
    width: 44px;
    height: 44px;
    flex-shrink: 0;
    border: none;
    border-radius: 0 10px 10px 0;
    background: ${({ theme }) => theme.colors.accentColor};
    color: ${({ theme }) => theme.colors.colorTextLightSolid};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`;

export const ResultsList = styled.div`
    margin-top: 12px;
    max-height: 320px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const ResultItem = styled.button`
    display: flex;
    gap: 12px;
    align-items: center;
    width: 100%;
    text-align: left;
    cursor: pointer;
    background: ${({ theme }) => theme.colors.colorFillAlter};
    border: 1px solid ${({ theme }) => theme.colors.antdBorderSecondary};
    border-radius: 10px;
    padding: 10px 12px;

    &:hover {
        border-color: ${({ theme }) => theme.colors.accentColor};
    }
`;

export const ResultsMessage = styled.div`
    margin-top: 12px;
    text-align: center;
    font-size: 13px;
    color: ${({ theme }) => theme.colors.lightFont};
`;

export const Banner = styled.div<{ $tone: 'warning' | 'info' }>`
    display: flex;
    gap: 10px;
    align-items: flex-start;
    padding: 12px 14px;
    border-radius: 10px;
    margin-bottom: 14px;
    font-size: 13px;
    line-height: 1.4;
    ${({ $tone }) =>
        $tone === 'warning'
            ? css`
                  background: ${({ theme }) => theme.colors.colorWarningBg};
                  border: 1px solid
                      ${({ theme }) => theme.colors.colorWarningBorder};
                  color: ${({ theme }) => theme.colors.colorWarningText};
              `
            : css`
                  background: ${({ theme }) => theme.colors.colorPrimaryBg};
                  border: 1px solid
                      ${({ theme }) => theme.colors.colorPrimaryBorder};
                  color: ${({ theme }) => theme.colors.colorPrimaryText};
              `}

    svg {
        flex-shrink: 0;
        margin-top: 1px;
    }
`;

export const BannerTitle = styled.strong`
    display: block;
    font-weight: 700;
`;

export const InfoGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1px;
    background: ${({ theme }) => theme.colors.antdBorderSecondary};
    border: 1px solid ${({ theme }) => theme.colors.antdBorderSecondary};
    border-radius: 10px;
    overflow: hidden;
    margin-bottom: 14px;
`;

export const InfoCell = styled.div`
    background: ${({ theme }) => theme.colors.colorBgContainer};
    padding: 8px 12px;
`;

export const InfoCellLabel = styled.div`
    font-size: 11px;
    color: ${({ theme }) => theme.colors.antdTextSecondary};
    margin-bottom: 2px;
`;

export const InfoCellValue = styled.div<{ $accent?: boolean }>`
    font-size: 14px;
    font-weight: 700;
    color: ${({ $accent, theme }) =>
        $accent ? theme.colors.accentColor : theme.colors.antdText};
`;

export const GlobalPanel = styled.div`
    background: ${({ theme }) => theme.colors.colorPrimaryBg};
    border: 1px solid ${({ theme }) => theme.colors.colorPrimaryBorder};
    border-radius: 12px;
    padding: 14px;
`;

export const GlobalPanelTitle = styled.div`
    font-size: 13px;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.colorPrimaryText};
    margin-bottom: 10px;
`;

export const GlobalNote = styled.div`
    font-size: 12px;
    color: ${({ theme }) => theme.colors.antdTextSecondary};
    margin: 10px 0 14px;
`;

export const GlobalActions = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const FieldsRow = styled.div`
    display: flex;
    gap: 12px;
    margin-bottom: 14px;
`;

export const FieldsRowGrow = styled.div`
    flex: 1;
    min-width: 0;
`;

export const TwoColumnGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px 12px;
    margin-bottom: 18px;
`;

export const ImageDropzone = styled.div`
    width: 76px;

    .ant-upload.ant-upload-drag {
        height: 76px;
        border: 1px dashed ${({ theme }) => theme.colors.antdBorder};
        border-radius: 10px;
        background: ${({ theme }) => theme.colors.colorFillAlter};
        overflow: hidden;
    }

    .ant-upload.ant-upload-drag .ant-upload {
        padding: 0;
    }

    .ant-upload-btn {
        display: flex !important;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 76px;
        padding: 0 !important;
        font-size: 10px;
        line-height: 1.2;
        text-align: center;
        color: ${({ theme }) => theme.colors.colorTextTertiary};
    }

    .ant-upload-drag-container {
        display: flex !important;
        flex-direction: column;
        align-items: center;
        gap: 2px;

        span {
            font-size: 13px;
            color: ${({ theme }) => theme.colors.antdTextSecondary};
        }

        u {
            font-size: 11px;
            color: ${({ theme }) => theme.colors.colorTextTertiary};
        }
    }

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;

export const FieldGroup = styled.div`
    margin-bottom: 14px;
`;

export const ReadOnlyValue = styled.div`
    height: 42px;
    display: flex;
    align-items: center;
    padding: 0 12px;
    color: ${({ theme }) => theme.colors.antdTextSecondary};
    border: 1px solid ${({ theme }) => theme.colors.antdBorderSecondary};
    border-radius: 10px;
    background: ${({ theme }) => theme.colors.colorFillAlter};
    font-family: 'SFMono-Regular', Consolas, monospace;
    font-size: 14px;
`;

export const Footer = styled.div`
    display: flex;
    gap: 10px;
    width: 100%;

    .ant-btn {
        height: 44px;
        border-radius: 10px;
        font-weight: 700;
    }

    .ant-btn-default:not(:disabled) {
        border-color: ${({ theme }) => theme.colors.antdBorderSecondary};
        color: ${({ theme }) => theme.colors.antdText};

        &:hover {
            border-color: ${({ theme }) => theme.colors.secondaryColor};
            color: ${({ theme }) => theme.colors.accentColor};
        }
    }

    .ant-btn-primary:not(:disabled) {
        background: ${({ theme }) => theme.colors.accentColor};
        box-shadow: none;

        &:hover {
            background: ${({ theme }) => theme.colors.colorPrimaryHover};
        }
    }
`;

export const FooterSecondary = styled.div<{ $basis?: string }>`
    flex: ${({ $basis }) => `0 0 ${$basis ?? 'auto'}`};
    display: flex;

    .ant-btn {
        width: 100%;
    }
`;

export const FooterPrimary = styled.div`
    flex: 1;
    display: flex;

    .ant-btn {
        width: 100%;
    }
`;

export const FooterLink = styled(FooterPrimary)`
    .ant-btn-default:not(:disabled) {
        color: ${({ theme }) => theme.colors.accentColor};
    }
`;
